import { useParams } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import navConfig from './navConfig.json';
import ProfileNav from "./ProfileNav.jsx";
import Post_content from '../../community/content/Blog_posts.jsx';
function Home() {
  const { slug_2 } = useParams();

  // Tìm cấu hình theo slug_2 từ JSON
  const currentRoute = navConfig.find(item => item.slug_2 === slug_2);

  if (!currentRoute) {
    return <div>Không tìm thấy trang</div>;
  }

  // Dùng React.lazy để load component dựa vào componentPath trong JSON
  const ComponentToRender = lazy(() => import(`${currentRoute.componentPath}`));

  return (
    <>
      <div className="text-center">
        <div className="inline-block border-gray-200 text-center font-medium text-gray-500 bg-slate-100 mt-2 py-1 px-2 rounded-xl">
          <ProfileNav />
        </div>
      </div>
      <Suspense fallback={<div>Loading...</div>}>
        {slug_2 === "tricks" ? (
          <div className="mt-1 mb-3">
            {/* Truyền props nếu cần cho component Post_content */}
            <Post_content mode={'telegram'} show_adsense="YES" channel="freefltiktok" id_post="69" />
          </div>
        ) : (
          <ComponentToRender />
        )}
      </Suspense>
    </>
  );
}

export default Home;
